import { $agriculture } from '@/modules/agriculture/store/agriculture.store';
import { ButtonMain } from '@/modules/common/components/button';
import {
  $mixingParamsData,
  $myWarehouses,
  fetchMixingParamsData,
  fetchMyWarehouses,
} from '@/widgets/recipe/model';
import { notification } from 'antd';
import { useStore } from 'effector-react';
import { isEqual } from 'lodash-es';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AGRICULTURES, SEARCH_BY_RANGES_LOCAL_STORAGE_KEY } from '../../constants';
import { submitRangesFx } from '../../functions/submit-ranges-search.function';
import {
  $searchByRanges,
  searchInitialState,
  setValuesToSearchByRanges,
  setWarehousesToSearchByRanges,
} from '../../store/search-by-params.store';
import { IMockStore } from '../../ts/index.types';
import { TopFiltersBar } from '../top-filters-bar';
import { MidRangesBar } from './components/mid-ranges-bar';
import styles from './index.module.sass';

export const ByRangesSearch = () => {
  const warehouses = useStore($myWarehouses);
  const searchState = useStore($searchByRanges);
  const resultData: any = useStore($mixingParamsData);

  const agricultures = useStore($agriculture);

  const wheat = agricultures.find((item) => item.name === AGRICULTURES[0].name);
  const wheatRanges = {
    gluten: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[0].name,
    ),
    humidity: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[1].name,
    ),
    idk: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[2].name,
    ),
    cp: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[3].name,
    ),
    protein: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[4].name,
    ),
    nature: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[5].name,
    ),
  };

  const selectStoreHandler = (option: IMockStore) => {
    const updatedValue = searchState?.stores?.map((item) => {
      if (item.id === option.id)
        return {
          ...item,
          checked: !item.checked,
        };
      return item;
    });
    setWarehousesToSearchByRanges({ ...searchState, stores: updatedValue });
  };

  const selectAllStoresHandler = () => {
    const updatedValue = searchState?.stores?.map((item) => {
      return {
        ...item,
        checked: true,
      };
    });
    setWarehousesToSearchByRanges({ ...searchState, stores: updatedValue });
  };

  const deselectAllStoresHandler = () => {
    const updatedValue = searchState?.stores?.map((item) => {
      return {
        ...item,
        checked: false,
      };
    });
    setWarehousesToSearchByRanges({ ...searchState, stores: updatedValue });
  };

  useEffect(() => {
    // тут загрузка списка хранилищ от API
    fetchMyWarehouses();

    // отлов ошибки при отправке формы
    fetchMixingParamsData.failData.watch((error) =>
      notification.error({ message: 'Ошибка', description: error.message }),
    );
  }, []);

  useEffect(() => {
    if (warehouses) {
      const newSearchState = {
        ...searchState,
        stores: warehouses.map((item) => {
          const existingWarehouse = searchState.stores.find(
            (whs) => whs.id === item.id,
          );
          if (existingWarehouse) {
            return { ...existingWarehouse, label: item.name };
          }
          return {
            id: item.id,
            label: item.name,
            checked: false,
          };
        }),
      };
      setWarehousesToSearchByRanges(newSearchState);
      localStorage.setItem(
        SEARCH_BY_RANGES_LOCAL_STORAGE_KEY,
        JSON.stringify(newSearchState),
      );
    }
  }, [warehouses]);

  useEffect(() => {
    isEqual(searchState.rangesData, searchInitialState.rangesData) &&
      setRangesStateToDefault();
  }, [agricultures]);

  function setRangesStateToDefault() {
    setValuesToSearchByRanges({
      ...searchState,
      rangesData: {
        year: [
          (new Date().getFullYear() - 5).toString(),
          new Date().getFullYear().toString(),
        ],
        gluten: [
          wheatRanges.gluten?.options.min?.toString() || '0',
          wheatRanges.gluten?.options.max?.toString() || '1000',
        ],
        idk: [
          wheatRanges.idk?.options.min?.toString() || '0',
          wheatRanges.idk?.options.max?.toString() || '1000',
        ],
        clop: ['0', '100'],
        protein: [
          wheatRanges.protein?.options.min?.toString() || '0',
          wheatRanges.protein?.options.max?.toString() || '1000',
        ],
        cp: [
          wheatRanges.cp?.options.min?.toString() || '0',
          wheatRanges.cp?.options.max?.toString() || '1000',
        ],
        nature: [
          wheatRanges.nature?.options.min?.toString() || '0',
          wheatRanges.nature?.options.max?.toString() || '1000',
        ],
        humidity: [
          wheatRanges.humidity?.options.min?.toString() || '0',
          wheatRanges.humidity?.options.max?.toString() || '1000',
        ],
      },
    });
  }

  // useEffect(() => {
  //   if (searchState) {
  //     const res = indicateWheatType(searchState.wheatData.sort, searchState.wheatData.type)
  //     console.log('res- ', res)
  //   }
  // }, [searchState])

  const navigate = useNavigate();
  return (
    <div className={styles.root}>
      <TopFiltersBar
        stores={searchState.stores}
        onSelectStore={(option: IMockStore) => {
          selectStoreHandler(option);
        }}
        deselectAll={() => {
          deselectAllStoresHandler();
        }}
        onSelectAll={() => {
          selectAllStoresHandler();
        }}
      />
      <MidRangesBar setRangesStateToDefault={setRangesStateToDefault} />
      <ButtonMain
        className={styles.action}
        label="получить варианты"
        onClick={() =>
          submitRangesFx({
            data: searchState,
            navigate,
            resultData,
            wheatRangesForValidation: wheatRanges as any,
          })
        }
      />
    </div>
  );
};
